module.exports = __webpack_public_path__ + "img/lawtele3.5ba3f6e0.png";